var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1615 50C32.6437 50 30.2782 48.9617 28.5004 47.0775C27.5638 46.0838 26.321 45.5368 25.0004 45.5368C23.6799 45.5368 22.4371 46.0843 21.4999 47.0775C19.7227 48.9617 17.3572 50 14.8394 50C12.3211 50 9.95553 48.9617 8.17776 47.0775C4.52945 43.2086 4.52945 36.9135 8.17776 33.0451L13.4244 27.0957C16.4522 23.6631 20.5633 21.7722 25.0004 21.7722C29.4382 21.7722 33.5487 23.6631 36.5759 27.0957L41.8287 33.0523C45.4698 36.9218 45.4676 43.2113 41.822 47.0775C40.0448 48.9617 37.6793 50 35.1615 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7871 14.0121C14.9766 14.0121 12.821 12.0807 12.1221 8.79198C11.2466 4.67179 13.1082 0.772807 16.2721 0.100281C19.4365 -0.575024 22.7215 2.23236 23.5965 6.35199C24.4082 10.1709 22.6804 13.1173 19.1954 13.8587C18.711 13.9615 18.2404 14.0121 17.7871 14.0121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2132 14.0121C31.7593 14.0121 31.2893 13.9615 30.8049 13.8587C27.3199 13.1173 25.5921 10.1709 26.4032 6.35198C27.2788 2.23179 30.5649 -0.573923 33.7282 0.10027C36.8915 0.772796 38.7532 4.67233 37.8782 8.79197C37.1787 12.0801 35.0232 14.0121 32.2132 14.0121Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6776 24.8636C42.8137 24.8636 41.9253 24.6619 41.0676 24.2617C39.5798 23.5675 38.4887 22.4181 37.9959 21.0247C37.462 19.5151 37.6254 17.7621 38.467 15.9568C40.2465 12.1395 44.0781 10.1464 47.0098 11.5137C49.9408 12.881 50.8781 17.0995 49.0986 20.9168C48.257 22.7226 47.0198 23.9738 45.5209 24.5351C44.9348 24.7547 44.3125 24.8636 43.6776 24.8636Z",
    fill: "#256BE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32221 24.8637C5.68721 24.8637 5.06555 24.7547 4.47888 24.5352C2.98 23.9738 1.74279 22.7227 0.901124 20.9169C-0.877755 17.0996 0.0589065 12.8816 2.99 11.5137C5.92165 10.1476 9.75385 12.1396 11.5327 15.9574C12.3744 17.7632 12.5372 19.5151 12.0033 21.0253C11.5105 22.4187 10.42 23.5681 8.93164 24.2623C8.07442 24.6619 7.18609 24.8637 6.32221 24.8637Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.450dd347ac385234d1cb3b2038db1b8f.svg";
export { ForwardRef as ReactComponent };